import { render, staticRenderFns } from "./learner-proficiency.vue?vue&type=template&id=f593e1d0"
import script from "./learner-proficiency.ts?vue&type=script&lang=ts&external"
export * from "./learner-proficiency.ts?vue&type=script&lang=ts&external"
import style0 from "./learner-proficiency.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports